import Vue from 'vue'
import Router from 'vue-router'
import Tieba from './views/Tieba.vue'
import Album from './views/album/Album.vue'
import AlbumList from './views/album/AlbumList.vue'
import KugoAlbumList from './views/album/KugoAlbumList.vue'
import BilibiliList from './views/bilibili/BilibiliList.vue'
import CelebrityList from './views/CelebrityList.vue'
import CelebrityList2 from './views/CelebrityList2.vue'
import Doki from './views/Doki.vue'
import News from './views/News.vue'
import Episode1 from './views/episode/Episode1.vue'
import Episode2 from './views/episode/Episode2.vue'
import Episode3 from './views/episode/Episode3.vue'
import Episode4 from './views/episode/Episode4.vue'
import Episode5 from './views/episode/Episode5.vue'
import WeiboStats from './views/WeiboStats.vue'
import WeiboConfig from './views/admin/WeiboConfig.vue'
import NotificationAdmin from '@/views/admin/NotificationAdmin'
import MenuAdmin from './views/admin/MenuAdmin.vue'
import ConfigAdmin from './views/admin/ConfigAdmin'
import LoginView from './views/user/LoginView'
import FantuanList from './views/FantuanList'
import BearerList from './views/BearerList'
import BearerDetails from './views/BearerDetails'
import HotList from './views/HotList'
import ZhihuClub from './views/ZhihuClub'
import Xunyee from './views/Xunyee'
import BilibiliChannel from './views/bilibili/BilibiliChannel'
import Owhat from './views/Owhat'
import Douyin from './views/Douyin'
import MmHome from '@/views/mm/MmHome'
import StarList from '@/views/mm/StarList'
import StarInfo from '@/views/mm/StarInfo'
import UserInfo from '@/views/mm/UserInfo'
import UserList from '@/views/mm/UserList'
import UserRank from '@/views/mm/UserRank'
import CatList from '@/views/mm/CatList'
import RegisterView from '@/views/user/RegisterView'
import InvitationAdmin from '@/views/admin/InvitationAdmin'
import UserAdmin from '@/views/admin/UserAdmin'
import ApplyList from '@/views/mm/ApplyList'
import AccountInfo from '@/views/user/AccountInfo'
import AdminHome from '@/views/admin/AdminHome'
import SystemInfo from '@/views/admin/SystemInfo'
import UserMessage from '@/views/user/UserMessage'
import Home from '@/views/Home'
import WeiboList from '@/views/WeiboList'
import WeiboLogin from '@/views/user/WeiboLogin'
import WeiboUser from "@/views/user/WeiboUser";
import BaiduIndex from "@/views/BaiduIndex";
import EpisodeHot from "@/views/EpisodeHot.vue";
import Search from "@/views/Search.vue";
import Texts from "@/views/episode/Texts.vue";
import DanmuList from "@/views/episode/DanmuList.vue";
import Episode from "@/views/episode/Episode.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/albumHistory/:id',
      component: Album
    },
    {
      path: '/albumData/:id',
      component: AlbumList
    },
    {
      path: '/kugo/:id',
      component: KugoAlbumList
    },
    {
      path: '/douyin',
      component: Douyin
    },
    {
      path: '/tieba',
      component: Tieba
    },
    {
      path: '/bilibili/channel',
      component: BilibiliChannel
    },
    {
      path: '/bilibili',
      component: BilibiliList
    },
    {
      path: '/bilibili/:page',
      component: BilibiliList
    },
    {
      path: '/hot',
      component: HotList
    },
    {
      path: '/maoyan',
      component: CelebrityList
    },
    {
      path: '/maoyan2',
      component: CelebrityList2
    },
    {
      path: '/fantuan',
      component: FantuanList
    },
    {
      path: '/sport',
      component: BearerList
    },
    {
      path: '/sport/:id',
      component: BearerDetails
    },
    {
      path: '/doki',
      component: Doki
    },
    {
      path: '/news',
      component: News
    },
    {
      path: '/search',
      component: Search,
      meta: { admin: true }
    },
    {
      path: '/episode-hot',
      component: EpisodeHot
    },
    {
      path: '/episodes',
      component: Episode
    },
    {
      path: '/episodes1',
      component: Episode1
    },
    {
      path: '/episodes2',
      component: Episode2
    },
    {
      path: '/episodes3',
      component: Episode3
    },
    {
      path: '/episodes4',
      component: Episode4
    },
    {
      path: '/episodes5',
      component: Episode5,
      meta: { auth: true }
    },
    {
      path: '/danmu',
      component: DanmuList
    },
    {
      path: '/texts',
      component: Texts,
      meta: { auth: true }
    },
    {
      path: '/weibo/stats',
      component: WeiboStats
    },
    {
      path: '/weibo',
      component: WeiboList,
    },
    {
      path: '/weibo-login',
      component: WeiboLogin,
    },
    {
      path: '/zhihu',
      component: ZhihuClub
    },
    {
      path: '/baidu/index',
      component: BaiduIndex
    },
    {
      path: '/xunyee',
      component: Xunyee
    },
    {
      path: '/mm',
      component: MmHome,
      redirect: '/mm/cats',
      meta: { auth: true },
      children: [
        {
          path: 'stars',
          component: StarList,
          meta: { auth: true }
        },
        {
          path: 'stars/:id',
          component: StarInfo,
          meta: { auth: true }
        },
        {
          path: 'rank',
          component: UserRank,
          meta: { auth: true }
        },
        {
          path: 'users',
          component: UserList,
          meta: { auth: true }
        },
        {
          path: 'cats',
          component: CatList,
          meta: { auth: true }
        },
        {
          path: 'apply',
          component: ApplyList,
          meta: { auth: true }
        },
        {
          path: 'users/:id',
          name: 'UserInfo',
          component: UserInfo,
          meta: { auth: true }
        },
        {
          path: 'fans/:id',
          name: 'FanInfo',
          component: UserInfo,
          meta: { auth: true }
        },
      ]
    },
    {
      path: '/admin',
      component: AdminHome,
      redirect: '/admin/info',
      meta: { admin: true },
      children: [
        {
          path: 'info',
          component: SystemInfo,
          meta: { admin: true }
        },
        {
          path: 'owhat',
          component: Owhat,
          meta: { admin: true }
        },
        {
          path: 'weibo',
          component: WeiboConfig,
          meta: { admin: true }
        },
        {
          path: 'notification',
          component: NotificationAdmin,
          meta: { admin: true }
        },
        {
          path: 'menu',
          component: MenuAdmin,
          meta: { admin: true }
        },
        {
          path: 'config',
          component: ConfigAdmin,
          meta: { admin: true }
        },
        {
          path: 'user',
          component: UserAdmin,
          meta: { admin: true }
        },
        {
          path: 'invitation',
          component: InvitationAdmin,
          meta: { admin: true }
        },
      ]
    },
    {
      path: '/login',
      component: LoginView,
      meta: { guest: true }
    },
    {
      path: '/register',
      component: RegisterView,
      meta: { guest: true }
    },
    {
      path: '/user',
      component: AccountInfo,
      meta: { auth: true }
    },
    {
      path: '/user/weibo',
      component: WeiboUser,
      meta: { auth: true }
    },
    {
      path: '/message',
      component: UserMessage,
      meta: { auth: true }
    },
  ],
  linkActiveClass: 'active'
})
